import { Guid } from '@web/utils';

export class PublicBrand {
  public constructor(
    public readonly id: Guid,
    public readonly name: string,
    public readonly slug: string,
    public readonly logoAlt: string,
    public readonly logoSrc: string,
  ) {}
}
